var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserShield01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.41793 22.2082C7.66495 22.0684 7.89175 21.9401 8.08705 21.8238C12.2197 19.3631 17.3496 19.1108 21.6867 21.0671C21.4881 21.1559 21.2876 21.2347 21.0823 21.2969C20.5342 21.463 20.2602 21.5461 20.1493 21.6632C20.0384 21.7803 20.0059 21.9514 19.9409 22.2936C19.2756 25.7989 20.6392 29.051 23.935 30.4785C23.2515 30.7297 22.5218 30.871 21.7327 30.871H9.49344C7.34855 30.871 5.64252 29.8273 4.11072 28.3679C1.28682 25.6776 5.18126 23.4739 7.41793 22.2082Z",
    fill: "url(#paint0_linear_5215_13828)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32631 9.35786C8.32631 5.33353 11.5887 2.07117 15.613 2.07117C19.6373 2.07117 22.8997 5.33353 22.8997 9.35786C22.8997 13.3822 19.6373 16.6446 15.613 16.6446C11.5887 16.6446 8.32631 13.3822 8.32631 9.35786ZM15.613 4.15308C12.7385 4.15308 10.4082 6.48334 10.4082 9.35786C10.4082 12.2324 12.7385 14.5626 15.613 14.5626C18.4875 14.5626 20.8178 12.2324 20.8178 9.35786C20.8178 6.48334 18.4875 4.15308 15.613 4.15308Z",
    fill: "url(#paint1_linear_5215_13828)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9044 20.8685C14.0528 20.6021 11.1347 21.2207 8.6198 22.7182C8.38688 22.8569 8.13166 23.0017 7.86433 23.1533C6.87527 23.7144 5.72008 24.3698 4.91494 25.1579C4.41511 25.6471 4.20204 26.0507 4.16796 26.3626C4.1409 26.6101 4.20348 27.0184 4.82893 27.6142C6.26663 28.9839 7.72755 29.83 9.49363 29.83H18.3891C18.964 29.83 19.4301 30.2961 19.4301 30.871C19.4301 31.4459 18.964 31.9119 18.3891 31.9119H9.49363C6.96992 31.9119 5.01877 30.6706 3.39287 29.1216C2.45043 28.2237 1.98066 27.2132 2.09837 26.1363C2.20905 25.1238 2.81788 24.2973 3.45865 23.6701C4.48318 22.6673 5.97871 21.8235 6.96805 21.2654C7.19382 21.138 7.39323 21.0255 7.55467 20.9294C10.4611 19.1987 13.8223 18.4896 17.098 18.7957C17.6704 18.8491 18.0911 19.3565 18.0376 19.9289C17.9842 20.5014 17.4768 20.922 16.9044 20.8685Z",
    fill: "url(#paint2_linear_5215_13828)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3276 18.7265C24.2147 18.7265 23.3209 19.086 22.5916 19.445C22.344 19.5668 22.1298 19.6792 21.9351 19.7813C21.505 20.0069 21.1699 20.1826 20.7803 20.3007L20.752 20.3093C20.5025 20.3849 20.2704 20.4552 20.0887 20.5229C19.9329 20.5809 19.6295 20.6982 19.3935 20.9473C19.1854 21.1671 19.0871 21.4077 19.031 21.5944C18.9847 21.7484 18.9512 21.9257 18.9238 22.0705L18.9183 22.0995C18.1446 26.1756 19.8508 30.116 24.0322 31.6369L24.0655 31.649C24.4446 31.7871 24.7875 31.9119 25.3296 31.9119C25.8716 31.9119 26.2145 31.7871 26.5936 31.649L26.6269 31.6368C30.8084 30.1159 32.5127 26.1752 31.7389 22.0994L31.7334 22.0705C31.706 21.9256 31.6724 21.7483 31.6262 21.5943C31.5701 21.4076 31.4717 21.1669 31.2635 20.9472C31.0275 20.698 30.7241 20.5808 30.5683 20.5228C30.3866 20.4552 30.1546 20.3849 29.905 20.3093L29.8767 20.3007C29.4868 20.1826 29.1515 20.0068 28.721 19.7812C28.5262 19.6791 28.3119 19.5667 28.0642 19.4449C27.3346 19.086 26.4405 18.7265 25.3276 18.7265ZM23.0694 21.5402C23.2284 21.4568 23.3769 21.3789 23.5109 21.3129C24.1279 21.0093 24.6828 20.8084 25.3276 20.8084C25.9726 20.8084 26.5278 21.0093 27.1453 21.3131C27.2795 21.3791 27.428 21.4569 27.5871 21.5403C28.0825 21.8 28.681 22.1138 29.273 22.2932C29.4483 22.3463 29.5792 22.3861 29.6804 22.4187L29.6935 22.4877C30.3102 25.7356 28.9791 28.5659 25.9153 29.6803C25.5294 29.8207 25.487 29.83 25.3295 29.83C25.1721 29.83 25.1297 29.8207 24.7438 29.6803C21.6794 28.5658 20.3473 25.7352 20.9637 22.4877L20.9768 22.4187C21.078 22.3861 21.2089 22.3462 21.3843 22.2931C21.9761 22.1137 22.5744 21.7999 23.0694 21.5402Z",
    fill: "url(#paint3_linear_5215_13828)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5215_13828",
    x1: 13.5283,
    y1: 19.7675,
    x2: 13.5283,
    y2: 30.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6983"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5215_13828",
    x1: 17.0004,
    y1: 2.07117,
    x2: 17.0004,
    y2: 31.9119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6983"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5215_13828",
    x1: 17.0004,
    y1: 2.07117,
    x2: 17.0004,
    y2: 31.9119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6983"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5215_13828",
    x1: 17.0004,
    y1: 2.07117,
    x2: 17.0004,
    y2: 31.9119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6983"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserShield01);
export default __webpack_public_path__ + "static/media/user-shield-01.a51fe2e2d5fbea6585f862c0d1235442.svg";
export { ForwardRef as ReactComponent };